const LIGHT_TYPES = {
  street_light: 'Street Light',
  private_area: 'Private Area',
}

const PROBLEM_TYPES = {
  light_out: 'Light out',
  day_burner: 'Day Burner (Light on during day)',
  light_noisy: 'Light noisy',
  light_dim: 'Light dim',
  light_cycling: 'Light cycling on/off',
  animal_nest: 'Animal nest',
  exposed_wire: 'Exposed Wire',
  others: 'Other (Explain in Comments)',
}

export default {
  LIGHT_TYPES, PROBLEM_TYPES,
}
